import React, { useState } from 'react';
import axios from 'axios';
import { Calculator } from 'lucide-react';
import { formatInr } from '../lib/formatInr';
import { GstSplitText } from './GstSplitText';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const RecalculatePaymentCard = ({ bookingId, onDone }) => {
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState('');

  const call = async (dryRun) => {
    setBusy(true); setError('');
    try {
      const res = await axios.post(`${API}/admin/bookings/${bookingId}/recalculate-payment`, { dry_run: dryRun });
      if (dryRun) { setPreview(res.data); setDone(''); }
      else { setPreview(null); setDone(`Updated → ${res.data.after.payment_status.toUpperCase()}`); onDone && onDone(); }
    } catch (e) {
      setError(e?.response?.data?.detail || 'Recalculation failed');
    } finally { setBusy(false); }
  };

  const a = preview?.after;
  return (
    <div className="p-3 border-2 border-dashed border-black font-mono text-xs" data-testid="recalc-payment-card">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <span className="font-bold uppercase flex items-center gap-1"><Calculator size={12} />Payment check</span>
        <button data-testid="recalc-preview-btn" onClick={() => call(true)} disabled={busy}
          className="px-2 py-1 border-2 border-black bg-white uppercase font-bold hover:bg-gray-100 disabled:opacity-50">
          {busy && !preview ? 'Checking…' : 'Recalculate payment'}
        </button>
      </div>
      {preview && (
        <div className="mt-2 space-y-1" data-testid="recalc-preview">
          <div>Collected in Razorpay: <b>{formatInr(preview.collected)}</b>{preview.refunded > 0 && <> · Refunded: <b>{formatInr(preview.refunded)}</b></>}</div>
          <div>Order total: <b>{formatInr(preview.order_total)}</b></div>
          <div data-testid="recalc-result">
            Result: <b>{a.payment_status.toUpperCase()}</b>
            {a.top_up_amount > 0 && <> · <b className="text-red-700">{formatInr(a.top_up_amount)} due</b> <GstSplitText split={preview.difference_split} /></>}
            {a.pending_refund_amount > 0 && <> · <b className="text-green-700">{formatInr(a.pending_refund_amount)} to refund</b></>}
          </div>
          {preview.stale_orders.length > 0 && (
            <div className="text-gray-600">{preview.stale_orders.length} unpaid Razorpay request(s) will be closed.</div>
          )}
          <div className="text-gray-600">No message is sent to the customer.</div>
          <div className="flex gap-2 pt-1">
            <button data-testid="recalc-apply-btn" onClick={() => call(false)} disabled={busy}
              className="px-3 py-1 border-2 border-black bg-[#FF4500] uppercase font-bold disabled:opacity-50">
              {busy ? 'Saving…' : 'Apply'}
            </button>
            <button data-testid="recalc-cancel-btn" onClick={() => setPreview(null)} className="px-3 py-1 border-2 border-black bg-white uppercase">Cancel</button>
          </div>
        </div>
      )}
      {error && <div className="mt-2 text-red-600" data-testid="recalc-error">{error}</div>}
      {done && <div className="mt-2 text-green-700 font-bold" data-testid="recalc-done">{done}</div>}
    </div>
  );
};
